// Client-side validation for the customer-care forms (Query, Complaint, Suggestion).
// Mirrors Email_service/middleware/validateFeedback.js, which re-checks everything on the server.

const NO_MARKUP = /^[^<>]*$/;

// Keyed by formData field names. Fields a form doesn't have are skipped.
const FIELD_RULES = {
  fullName: { label: "Full Name", required: true, max: 100, pattern: /^\p{L}[\p{L} .'-]*$/u },
  flat: { label: "Flat/Door/Block No.", max: 100, pattern: NO_MARKUP },
  building: { label: "Building", max: 100, pattern: NO_MARKUP },
  village: { label: "Village", max: 100, pattern: NO_MARKUP },
  road: { label: "Road/Street", max: 100, pattern: NO_MARKUP },
  locality: { label: "Area/Locality", max: 100, pattern: NO_MARKUP },
  city: { label: "City", max: 50, pattern: NO_MARKUP },
  state: { label: "State", required: true, max: 50 },
  pin: { label: "PIN", max: 6, pattern: /^[1-9][0-9]{5}$/, hint: "must be a 6-digit number" },
  phone: { label: "Telephone No.", max: 20, pattern: /^[0-9+\-() ]{6,20}$/, hint: "must be 6–20 digits" },
  email: { label: "Email ID", required: true, max: 254, pattern: /^[^\s@<>()]+@[^\s@<>()]+\.[A-Za-z]{2,}$/ },
  pan: { label: "PAN", max: 10, pattern: /^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/, hint: "must be in the format ABCDE1234F" },
  complaintArea: { label: "Area", max: 100 },
  complaint: { label: "Details", max: 2000 },
};

// Returns the first error as { field, message }, or null if the form is valid.
export const validateFeedbackForm = (formData, enterCaptchaCode) => {
  for (const [key, rule] of Object.entries(FIELD_RULES)) {
    if (!(key in formData)) continue;

    const value = String(formData[key] ?? "").trim();
    if (!value) {
      if (rule.required) return { field: key, message: `${rule.label} is required` };
      continue;
    }
    if (value.length > rule.max) return { field: key, message: `${rule.label} must be at most ${rule.max} characters` };
    if (rule.pattern && !rule.pattern.test(value)) return { field: key, message: `${rule.label} ${rule.hint || "is invalid"}` };
  }

  if (formData.consent !== true && formData.consent !== false) {
    return { field: "consent", message: 'Please select "Yes" or "No" for the consent statement' };
  }

  const captcha = String(enterCaptchaCode ?? "").trim();
  if (!captcha) return { field: "captcha", message: "Please enter the captcha code" };
  if (captcha.length > 10) return { field: "captcha", message: "Captcha code is invalid" };

  return null;
};
